const links = [
    {
     label: "Github",
     url: "https://github.com/FranciscoBSpadaro"
    },
    {
        label: "Whatsapp",
        url: "https://api.whatsapp.com/send?phone=5513997089569"
       },
       {
        label: "Linkedin",
        url: "https://www.linkedin.com/in/franciscobspadaro/"
       },
       {
        label: "Email",
        url: "mailto:francisco.spadaro@outlook.com"
       },

]
export default links
